import { Controller } from "@hotwired/stimulus"

// Reveal hidden list items in batches (e.g. related games "Show more").
export default class extends Controller {
  static targets = ["item", "button"]
  static values = { pageSize: { type: Number, default: 4 } }

  show(event) {
    event.preventDefault()

    const hidden = this.itemTargets.filter((item) => item.hidden)
    hidden.slice(0, this.pageSizeValue).forEach((item) => {
      item.hidden = false
    })

    if (this.hasButtonTarget && hidden.length <= this.pageSizeValue) {
      this.buttonTarget.hidden = true
    }
  }
}
